/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Discounts {
    angular.module("meevo.plugins.discounts", []);
}